export const LOGIN_SUCCESS= "LOGIN_SUCCESS"
export const LOGIN_FAILED= "LOGIN_FAILED"
export const IS_USER_LOGINED= "IS_USER_LOGINED"
export const USER_LOGOUT= "USER_LOGOUT"
export const NAVBAR_TOGGLE= "NAVBAR_TOGGLE"